<article class="cej-orientation-solutions">
  <button
    mat-icon-button
    type="button"
    aria-label="Fermer la carte de résultat"
    class="btn-clean btn-close cej-orientation-solutions__cross-btn"
    (click)="close()"
  >
    <mat-icon svgIcon="cross" role="presentation"></mat-icon>
  </button>
  <h2 class="cej-orientation-solutions__title">Découvrez les dispositifs référencés sur le portail 1jeune1solution</h2>
  <ul class="cej-orientation-solutions__list">
    <li
      class="cej-orientation-solutions__list__item"
      *ngFor="let solution of configSolutions; trackBy: trackByConfigSolutionTitle"
    >
      <a
        class="btn-clean cej-orientation-solutions__list__item__link"
        routerLink="/"
        [fragment]="solution.fragment"
        (click)="
          trackEvent({
            category: 'CEJ',
            action: 'Click Solutions',
            label: solution.trackEventLabel,
            type: 'navigation'
          })
        "
      >
        <mat-icon
          class="cej-orientation-solutions__list__item__icon"
          [svgIcon]="solution.icon"
          [style.color]="solution.color"
          role="presentation"
        ></mat-icon>
        <p>{{ solution.title }}</p>
      </a>
    </li>
  </ul>
  <button class="cej-orientation-solutions__close-btn btn-clean" (click)="close()">Fermer</button>
</article>
